import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    fontFamily: "Google Sans Flex",
    padding: "0",
    borderRadius: "12px",
    fontSize: "14px",
    backgroundColor: "#fbfbff",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e9ecef",
      borderWidth: "1px",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "1px solid #e9ecef",
    },
    "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
      borderColor: "#e9ecef !important",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#8642c7",
      borderWidth: "1px",
      boxShadow: "0 0 0 3px rgba(102, 126, 234, 0.1)",
    },
  },
  "& .MuiInputBase-input": {
    border: "0",
    fontSize: "14px",
    padding: "11px 12px !important",
    color: "#1a202c",
    "&::placeholder": {
      color: "#9ca3af",
      opacity: 1,
    },
    "&.Mui-disabled": {
      cursor: "not-allowed",
    },
  },
};

const paperSx = {
  borderRadius: "8px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
  "& .MuiAutocomplete-option": {
    fontFamily: "\"Google Sans Flex\", sans-serif",
    fontSize: "0.95rem",
    padding: "8px 16px",
    '&[aria-selected="true"]': {
      backgroundColor: "rgba(102, 126, 234, 0.12)",
      color: "#4f46e5",
    },
    "&.Mui-focused": {
      backgroundColor: "rgba(102, 126, 234, 0.07)",
    },
  },
};

interface SearchableSelectProps<T> {
  id: string;
  options: T[];
  getOptionLabel: (option: T) => string;
  value: T | null;
  onChange: (value: T | null) => void;
  isOptionEqualToValue: (option: T, value: T) => boolean;
  placeholder?: string;
  disabled?: boolean;
}

function SearchableSelect<T>({
  id,
  options,
  getOptionLabel,
  value,
  onChange,
  isOptionEqualToValue,
  placeholder,
  disabled,
}: SearchableSelectProps<T>) {
  return (
    <Autocomplete
      id={id}
      options={options}
      getOptionLabel={getOptionLabel}
      value={value}
      onChange={(_, newValue) => onChange(newValue)}
      isOptionEqualToValue={isOptionEqualToValue}
      disabled={disabled}
      disableClearable={false}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} sx={inputSx} />
      )}
      slotProps={{
        popper: { style: { zIndex: 10000 } },
        paper: { sx: paperSx },
      }}
    />
  );
}

export default SearchableSelect;
